import React from 'react';
import { BusinessGame } from '@/components/games/business/BusinessGame';
import { GameLayout } from '@/components/layout/GameLayout';

export default function BusinessGamePage() {
  return (
    <GameLayout
      title="Mi Primer Negocio"
      description="Aprende conceptos básicos de emprendimiento y liderazgo"
    >
      <BusinessGame />
    </GameLayout>
  );
}
